import React, { useCallback, useEffect, useState } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import type { Engine } from "tsparticles-engine";
import customOptions from "../Configs/particleOptions";
import { styled, useTheme } from "styled-components";

const TestContainer = styled.div`
    z-index: -1;
`;

export const ParticlesContainer: React.FC = () => {
    const customInit = useCallback(async (engine: Engine) => {
        await loadFull(engine);
    }, []);
    const theme = useTheme();

    const [currentOptions, setCurrentOptions] = useState(customOptions);

    useEffect(() => {
        const tempOptions = customOptions;
        tempOptions.background = theme.particlesBackground;
        tempOptions.style = {
            transition: `${theme.animationTime.short}s all ease`,
        };
        setCurrentOptions({ ...tempOptions });
    }, [theme]);

    return (
        <TestContainer>
            <Particles
                id="tsparticles"
                init={customInit}
                height="100vh"
                width="100%"
                options={currentOptions}
            />
        </TestContainer>
    );
};
